var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultFormWidgets } from '@juvare/common-form-ui/WidgetForm';
import { callConfigFunction, convertDataObjectToArray } from '@juvare/common-form-ui/WidgetForm/Utils';
import { valueProviderCache } from '@juvare/common-form-ui/valueProviderCache';
import { walkWidgetConfigTree } from '@juvare/common-form-ui/walkWidgetConfigTree';
import { formatDate, formatDateTime } from '@juvare/common-web-ui/utils';
import { getDataValue, removeDataValue, setDataValue } from '@juvare/json-data-util';
import { isValid, parseISO } from 'date-fns';
import { widgetFilterForm } from '../../WidgetFilterForm';
import { widgetFilterPanel } from '../../WidgetFilterPanel';
import { quickAdvancedSearchFilter } from './quickAdvancedSearchFilter';
import { quickFilterDatePicker } from './quickFilterDatePicker';
import { quickFilterDateRangePicker } from './quickFilterDateRangePicker';
import { quickFilterMultiSelect } from './quickFilterMultiSelect';
import { quickFilterSelect } from './quickFilterSelect';
import { quickSearchFilter } from './quickSearchFilter';
export function buildFilterConfig(callback, buildParams) {
    var _a, _b;
    const widgetsWithFilterWidgets = [
        ...((_b = (_a = buildParams.formConfigContext) === null || _a === void 0 ? void 0 : _a.widgets) !== null && _b !== void 0 ? _b : defaultFormWidgets),
        widgetFilterForm,
        widgetFilterPanel,
    ];
    const quickFilters = [];
    const allFiltersPanels = [];
    const filterDependencyMap = {};
    const getFilterChipFunctions = [];
    const addToFilterDependencyMap = (filterKey, paramsFromFormData) => {
        if (paramsFromFormData) {
            if (filterDependencyMap[paramsFromFormData]) {
                if (filterKey && !filterDependencyMap[paramsFromFormData].includes(filterKey)) {
                    filterDependencyMap[paramsFromFormData].push(filterKey);
                }
            }
            else {
                filterDependencyMap[paramsFromFormData] = filterKey ? [filterKey] : [];
            }
        }
    };
    const addQuickFilter = (partialFilterConfig, index) => {
        var _a, _b, _c, _d;
        if (partialFilterConfig.quickFilter) {
            quickFilters.splice(index != null ? index : quickFilters.length, 0, partialFilterConfig.quickFilter);
        }
        if (partialFilterConfig.getFilterChips) {
            getFilterChipFunctions.splice(index != null ? index : getFilterChipFunctions.length, 0, {
                quickFilterDataPath: (_a = partialFilterConfig.quickFilter) === null || _a === void 0 ? void 0 : _a.dataPath,
                function: partialFilterConfig.getFilterChips,
            });
        }
        const paramsFromFormData = (_c = (_b = partialFilterConfig.widgetConfig) === null || _b === void 0 ? void 0 : _b.valueProvider) === null || _c === void 0 ? void 0 : _c.paramsFromFormData;
        if (paramsFromFormData) {
            const quickFilterKey = (_d = partialFilterConfig.widgetConfig) === null || _d === void 0 ? void 0 : _d.key;
            if (quickFilterKey) {
                addToFilterDependencyMap(quickFilterKey, paramsFromFormData);
            }
        }
        return partialFilterConfig.widgetConfig;
    };
    const removeQuickFilter = (dataPath) => {
        const quickFilterIndex = quickFilters.findIndex((f) => f.dataPath === dataPath);
        if (quickFilterIndex !== -1) {
            quickFilters.splice(quickFilterIndex, 1);
        }
        const getFilterChipFunctionIndex = getFilterChipFunctions.findIndex((f) => f.quickFilterDataPath === dataPath);
        if (getFilterChipFunctionIndex !== -1) {
            getFilterChipFunctions.splice(getFilterChipFunctionIndex, 1);
        }
        if (filterDependencyMap[dataPath]) {
            delete filterDependencyMap[dataPath];
        }
        Object.keys(filterDependencyMap).forEach((dependencyKey) => {
            if (filterDependencyMap[dependencyKey].includes(dataPath)) {
                const index = filterDependencyMap[dependencyKey].indexOf(dataPath);
                filterDependencyMap[dependencyKey].splice(index, 1);
                if (filterDependencyMap[dependencyKey].length === 0) {
                    delete filterDependencyMap[dependencyKey];
                }
            }
        });
        return quickFilterIndex !== -1 ? quickFilterIndex : undefined;
    };
    const removeAllFiltersPanel = (key) => {
        for (let panelIndex = 0; panelIndex < allFiltersPanels.length; panelIndex++) {
            const panel = allFiltersPanels[panelIndex];
            if (panel.key === key) {
                allFiltersPanels.splice(panelIndex, 1);
                const keys = new Set();
                walkWidgetConfigTree(panel, widgetsWithFilterWidgets, (config) => {
                    if (config.key && !config.key.startsWith('!')) {
                        keys.add(config.key);
                    }
                });
                for (const key of keys) {
                    const index = getFilterChipFunctions.findIndex((f) => f.widgetKey === key);
                    if (index !== -1) {
                        getFilterChipFunctions.splice(index, 1);
                    }
                }
                break;
            }
        }
    };
    const findAllFiltersWidget = (key) => {
        for (const panel of allFiltersPanels) {
            let foundConfig = undefined;
            walkWidgetConfigTree(panel, widgetsWithFilterWidgets, (config) => {
                if (config.key === key) {
                    foundConfig = config;
                }
            });
            if (foundConfig) {
                return foundConfig;
            }
        }
        return undefined;
    };
    const removeAllFiltersWidgetChipFunction = (key) => {
        const chipFunctionIndex = getFilterChipFunctions.findIndex((f) => f.widgetKey === key);
        if (chipFunctionIndex !== -1) {
            getFilterChipFunctions.splice(chipFunctionIndex, 1);
        }
        return chipFunctionIndex !== -1 ? chipFunctionIndex : undefined;
    };
    callback({
        quickSearchFilter: (params, index) => {
            return addQuickFilter(quickSearchFilter(params), index);
        },
        quickFilterMultiSelect: (params, index) => {
            return addQuickFilter(quickFilterMultiSelect(Object.assign(Object.assign({}, params), { valueProviders: buildParams === null || buildParams === void 0 ? void 0 : buildParams.valueProviders, formConfigContext: buildParams === null || buildParams === void 0 ? void 0 : buildParams.formConfigContext })), index);
        },
        quickFilterSelect: (params, index) => {
            return addQuickFilter(quickFilterSelect(Object.assign(Object.assign({}, params), { valueProviders: buildParams === null || buildParams === void 0 ? void 0 : buildParams.valueProviders, formConfigContext: buildParams === null || buildParams === void 0 ? void 0 : buildParams.formConfigContext })), index);
        },
        quickDateFilter: (params) => {
            return addQuickFilter(quickFilterDatePicker(params));
        },
        quickDateRangeFilter: (params) => {
            return addQuickFilter(quickFilterDateRangePicker(params));
        },
        quickAdvancedSearchFilter: (params) => {
            return addQuickFilter(quickAdvancedSearchFilter(params));
        },
        allFiltersPanel: (config) => {
            allFiltersPanels.push(Object.assign(Object.assign({}, config), { type: 'filter.panel' }));
        },
        allFiltersWidget: (config, getFilterChips, chipFunctionIndex) => {
            var _a, _b, _c, _d;
            if (!getFilterChips) {
                getFilterChips = getFilterChipsFunctionForWidget(config, (_c = (_a = buildParams === null || buildParams === void 0 ? void 0 : buildParams.valueProviders) !== null && _a !== void 0 ? _a : (_b = buildParams === null || buildParams === void 0 ? void 0 : buildParams.formConfigContext) === null || _b === void 0 ? void 0 : _b.valueProviders) !== null && _c !== void 0 ? _c : [], filterDependencyMap);
            }
            if (getFilterChips) {
                getFilterChipFunctions.splice(chipFunctionIndex != null ? chipFunctionIndex : getFilterChipFunctions.length, 0, {
                    widgetKey: config.key,
                    function: getFilterChips,
                });
            }
            const paramsFromFormData = (_d = config.valueProvider) === null || _d === void 0 ? void 0 : _d.paramsFromFormData;
            if (paramsFromFormData) {
                const filterKey = config === null || config === void 0 ? void 0 : config.key;
                if (filterKey) {
                    addToFilterDependencyMap(filterKey, paramsFromFormData);
                }
            }
            return config;
        },
        removeQuickFilter,
        removeAllFiltersPanel,
        findAllFiltersWidget,
        removeAllFiltersWidgetChipFunction,
    });
    return {
        quickFilters: quickFilters.length > 0 ? quickFilters : undefined,
        allFilters: allFiltersPanels.length > 0
            ? {
                type: 'filter.form',
                children: allFiltersPanels,
            }
            : undefined,
        getFilterChips: getFilterChipFunctions.length > 0
            ? (filterData) => __awaiter(this, void 0, void 0, function* () {
                return (yield Promise.all(getFilterChipFunctions.map((getFilterChips) => getFilterChips.function(filterData, filterDependencyMap)))).flatMap((chips) => chips);
            })
            : undefined,
        filterDependencies: filterDependencyMap,
    };
}
function getFilterChipsFunctionForWidget(config, valueProviders, filterDependencyMap) {
    const key = config.key;
    if (key) {
        switch (config.type) {
            case 'form.checkbox':
            case 'form.yesNo':
                return getFilterChipsForCheckbox(config, key, filterDependencyMap);
            case 'form.number':
            case 'form.email':
            case 'form.phone':
            case 'form.text':
            case 'formUs.ssn':
                return getFilterChipsForText(key, filterDependencyMap);
            case 'form.advancedRadio':
            case 'form.radio':
            case 'form.select':
                return getFilterChipsForSelect(key, config, valueProviders, filterDependencyMap);
            case 'form.checkboxList':
            case 'form.multiSelect':
                return getFilterChipsForMultiSelect(key, config, valueProviders, filterDependencyMap);
            case 'form.date':
            case 'form.datePicker':
                return getFilterChipsForDate(key, filterDependencyMap);
            case 'form.dateTimePicker':
                return getFilterChipsForDateTime(key, config, filterDependencyMap);
            case 'form.dateTimeRangePicker':
                return getFilterChipsForDateTimeRange(key, config, filterDependencyMap);
            case 'form.colorPicker':
            case 'form.colorGradientPicker':
            case 'form.file':
            case 'form.googleReCaptchaV2':
            case 'form.html':
            case 'form.iconPicker':
            case 'form.image':
            case 'form.password':
            case 'form.richTextEditor':
                // These widgets do not have a default function to get filter chips.
                break;
        }
    }
    return undefined;
}
function getFilterChipsForText(key, filterDependencyMap) {
    return (data) => __awaiter(this, void 0, void 0, function* () {
        const value = getDataValue(data, key);
        if (value) {
            return [{ label: value, onRemoveChip: (data) => removeKey(data, key, filterDependencyMap), groupId: key }];
        }
        else {
            return [];
        }
    });
}
function getFilterChipsForCheckbox(config, key, filterDependencyMap) {
    var _a;
    let label = config.label;
    if (!label && 'labels' in config && ((_a = config.labels) === null || _a === void 0 ? void 0 : _a.yesLabel)) {
        label = config.labels.yesLabel;
    }
    if (label) {
        return (data) => __awaiter(this, void 0, void 0, function* () {
            const value = getDataValue(data, key);
            if (value) {
                return [
                    {
                        label: label !== null && label !== void 0 ? label : '',
                        onRemoveChip: (data) => removeKey(data, key, filterDependencyMap),
                        groupId: key,
                    },
                ];
            }
            else {
                return [];
            }
        });
    }
    return undefined;
}
function getFilterChipsForSelect(key, config, valueProviders, filterDependencyMap) {
    return (data) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const value = getDataValue(data, key);
        if (value != null) {
            const valueList = yield getWidgetValueList(config, valueProviders, data);
            const foundValue = valueList.find((v) => v.value === value);
            return [
                {
                    label: (_a = foundValue === null || foundValue === void 0 ? void 0 : foundValue.label) !== null && _a !== void 0 ? _a : value,
                    onRemoveChip: (data) => removeKey(data, key, filterDependencyMap),
                    groupId: key,
                },
            ];
        }
        else {
            return [];
        }
    });
}
function getFilterChipsForMultiSelect(key, config, valueProviders, filterDependencyMap) {
    return (data) => __awaiter(this, void 0, void 0, function* () {
        let values = getDataValue(data, key);
        if (typeof values === 'object' && !Array.isArray(values) && 'dataAsObject' in config && config.dataAsObject) {
            values = convertDataObjectToArray(values);
        }
        if (Array.isArray(values)) {
            const valueList = yield getWidgetValueList(config, valueProviders, data);
            return values.map((value) => {
                var _a, _b;
                return ({
                    label: (_b = (_a = valueList.find((v) => v.value === value)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : value,
                    onRemoveChip: (data) => removeArrayValue(data, key, value, filterDependencyMap),
                    groupId: key,
                });
            });
        }
        else {
            return [];
        }
    });
}
function getFilterChipsForDate(key, filterDependencyMap) {
    return (data) => __awaiter(this, void 0, void 0, function* () {
        const value = getDataValue(data, key);
        if (value != null) {
            const date = parseISO(value);
            return [
                {
                    label: isValid(date) ? formatDate(date) : value,
                    onRemoveChip: (data) => removeKey(data, key, filterDependencyMap),
                    groupId: key,
                },
            ];
        }
        else {
            return [];
        }
    });
}
function getFilterChipsForDateTime(key, config, filterDependencyMap) {
    return (data) => __awaiter(this, void 0, void 0, function* () {
        const value = getDataValue(data, key);
        if (value != null) {
            const date = config.isoString ? parseISO(value) : new Date(value);
            return [
                {
                    label: isValid(date) ? formatDateTime(date) : value,
                    onRemoveChip: (data) => removeKey(data, key, filterDependencyMap),
                    groupId: key,
                },
            ];
        }
        else {
            return [];
        }
    });
}
function getFilterChipsForDateTimeRange(key, config, filterDependencyMap) {
    return (data) => __awaiter(this, void 0, void 0, function* () {
        const { from, to } = getDataValue(data, key);
        if (from != null && to !== null) {
            let fromLabel;
            let toLabel;
            if (config.isoString) {
                fromLabel = typeof from === 'string' ? formatDateTime(parseISO(from)) : '' + from;
                toLabel = typeof to === 'string' ? formatDateTime(parseISO(to)) : '' + to;
            }
            else {
                fromLabel = typeof from === 'number' ? formatDateTime(new Date(from)) : '' + from;
                toLabel = typeof to === 'number' ? formatDateTime(new Date(to)) : '' + to;
            }
            return [
                {
                    label: fromLabel + ' - ' + toLabel,
                    onRemoveChip: (data) => removeKey(data, key, filterDependencyMap),
                    groupId: key,
                },
            ];
        }
        else {
            return [];
        }
    });
}
function getWidgetValueList(config, valueProviders, filterData) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        if (config.values) {
            return config.values;
        }
        else if ((_a = config.valueProvider) === null || _a === void 0 ? void 0 : _a.type) {
            const valueProvider = valueProviders.find((p) => { var _a; return p.type === ((_a = config.valueProvider) === null || _a === void 0 ? void 0 : _a.type); });
            if (valueProvider) {
                let params = (_b = config.valueProvider) === null || _b === void 0 ? void 0 : _b.params;
                if (((_c = config.valueProvider) === null || _c === void 0 ? void 0 : _c.paramsFromFormData) && filterData) {
                    params = getDataValue(filterData, (_d = config.valueProvider) === null || _d === void 0 ? void 0 : _d.paramsFromFormData);
                }
                return valueProviderCache.getValue(valueProvider, params);
            }
            else {
                return [];
            }
        }
        else if ((_e = config.valueProvider) === null || _e === void 0 ? void 0 : _e.custom) {
            return callConfigFunction(config.valueProvider.custom, 'valueProvider custom', 'handler');
        }
        else {
            return [];
        }
    });
}
function removeKey(data, key, dependencyMap) {
    const newFilterData = JSON.parse(JSON.stringify(data));
    removeDataValue(newFilterData, key);
    const dependantFilterArray = dependencyMap[key];
    if (dependantFilterArray && dependantFilterArray.length > 0) {
        dependantFilterArray.forEach((dependantFilterKey) => {
            removeDataValue(newFilterData, dependantFilterKey);
        });
    }
    return newFilterData;
}
function removeArrayValue(data, dataPath, valueToRemove, filterDependencyMap) {
    const newFilterData = JSON.parse(JSON.stringify(data));
    let newValues = getDataValue(newFilterData, dataPath);
    if (Array.isArray(newValues)) {
        newValues = newValues.filter((value) => value !== valueToRemove);
        setDataValue(newFilterData, dataPath, newValues.length > 0 ? newValues : undefined);
        if (newValues.length === 0) {
            const dependantFilterArray = filterDependencyMap[dataPath];
            if (dependantFilterArray && dependantFilterArray.length > 0) {
                dependantFilterArray.forEach((dependantFilterKey) => {
                    removeDataValue(newFilterData, dependantFilterKey);
                });
            }
        }
    }
    return newFilterData;
}
